export const tyroTuitionCoursesPathName =
  '/items/course?filter[status]=published&fields=*,course_date.*,tags.*';
export const tyroTuitionRegisterPathName = '/items/course_attendee_2';
export const tyroTuitionImageUrl = '/assets/';
export const tyroTuitionCoursesIdsPathName =
  '/items/course?filter[status]=published&fields[]=id';
